import { Card, Typography, Button, Box, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import React, { useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import Add from "../address/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { t } from "i18next";

const AddressList = ({ addresses, setSelectedAddress, SelectedAddress, count }) => {
  const [selectedAddressId, setSelectedAddressId] = useState("");
  const [selectedArea, setSelectedArea] = useState("");

  const handleAddressChange = (event) => {
    const selectedId = event.target.value;
    const selectedAddress = addresses.find(address => address.id === selectedId);
    if (selectedAddress) {
      setSelectedArea(selectedAddress.area);
      localStorage.setItem("address", selectedAddress.address);
      setSelectedAddress(selectedId);
      count(1);
    }
    setSelectedAddressId(selectedId);
  };

  const user_address = localStorage.getItem("address");

  return (
    <>
     <Typography variant="body2" sx={{ fontWeight: 'bold' , paddingBottom:2}}>1. Delivery Address</Typography>

      {SelectedAddress ? (
        <Card variant="outlined">
          <div className="selectedaddress-wrapper" style={{ padding: "20px" }}>
            <div className="address-title mb20">
              <Typography variant="h6" component="h5" className="bold">
                Delivery Address
                <CheckCircleIcon
                  color="error"
                  sx={{ verticalAlign: "middle", marginLeft: "20px" }}
                />
              </Typography>
            </div>
            <Typography variant="body1" component="h5" className="bold">
              {user_address}
            </Typography>
            <Typography
              variant="body2"
              component="h6"
              color="#8d8686"
              sx={{ mt: "10px" }}
            >
              {selectedArea}
            </Typography>

            {/* Dropdown to select a different address */}
            <Box mt={2} padding={3}>
              <FormControl fullWidth>

                <Select
                  labelId="address-select-label"
                  id="address-select"
                  value={selectedAddressId}
                  onChange={handleAddressChange}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    {t("Select Address")}
                  </MenuItem>
                  {addresses.map((adds) => (
                    <MenuItem key={adds.id} value={adds.id}>
                      <LocationOnIcon sx={{ marginRight: "10px" }} />
                      {adds.address}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
          </Box>
          </div>
        </Card>
      ) : (
        <FormControl fullWidth>
          <InputLabel id="address-select-label">{t("Select Address")}</InputLabel>
          <Select
            labelId="address-select-label"
            id="address-select"
            value={selectedAddressId}
            onChange={handleAddressChange}
            displayEmpty
          >
            <MenuItem value="" disabled>
              {t("Select Address")}
            </MenuItem>
            {addresses.map((adds) => (
              <MenuItem key={adds.id} value={adds.id}>
                <LocationOnIcon sx={{ marginRight: "10px" }} />
                {adds.address}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </>
  );
};

export default AddressList;
